import { render, staticRenderFns } from "./PatientProfileModal.vue?vue&type=template&id=2eeb4574&scoped=true&"
import script from "./PatientProfileModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PatientProfileModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PatientProfileModal.vue?vue&type=style&index=0&id=2eeb4574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeb4574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eeb4574')) {
      api.createRecord('2eeb4574', component.options)
    } else {
      api.reload('2eeb4574', component.options)
    }
    module.hot.accept("./PatientProfileModal.vue?vue&type=template&id=2eeb4574&scoped=true&", function () {
      api.rerender('2eeb4574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/mobile/PatientProfileModal.vue"
export default component.exports